(() => {
  if (window.__raCollectionCategoryNavInitialised) return;
  window.__raCollectionCategoryNavInitialised = true;

  const normalisePath = (value) => {
    try {
      return new URL(value, window.location.origin).pathname.replace(/\/$/, '') || '/';
    } catch (error) {
      return String(value || '').replace(/\/$/, '') || '/';
    }
  };

  const arrowMarkup = (direction) => direction === 'prev'
    ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.5 4 6.5 10l6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7.5 4 6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const isTargetSection = (section) => {
    if (!(section instanceof HTMLElement)) return false;
    const heading = (section.querySelector('.m-section__heading, .m-section__header h2, .m-section__header h3')?.textContent || '').trim().toLowerCase();
    return section.id === 'm-image-cards-image_with_text_1_KbnCC4' || heading.includes('naviga per categoria');
  };

  const setupSection = (section) => {
    if (!section || !isTargetSection(section)) return;

    section.querySelector('.ra-collection-category-nav__generated')?.remove();
    section.classList.add('ra-collection-category-nav');

    const cards = Array.from(section.querySelectorAll('.m-image-card'));
    const items = cards.map((card) => {
      const title = (card.querySelector('.m-image-card__heading')?.textContent || '').trim();
      const sourceLink = card.querySelector('.m-image-card__img[href], .m-richtext__button[href]');
      const href = sourceLink?.getAttribute('href') || '#';
      return title ? { title, href } : null;
    }).filter(Boolean);

    if (!items.length) return;

    const currentPath = normalisePath(window.location.pathname);
    const hasMatch = items.some((item) => normalisePath(item.href) === currentPath);
    const linksMarkup = items.map((item, index) => {
      const active = normalisePath(item.href) === currentPath || (!hasMatch && index === 0);
      return `<a class="ra-collection-category-nav__link${active ? ' is-active' : ''}" href="${item.href}" aria-label="${item.title.replace(/"/g, '&quot;')}">${item.title}</a>`;
    }).join('');

    const generated = document.createElement('div');
    generated.className = 'ra-collection-category-nav__generated';
    generated.innerHTML = `
      <button type="button" class="ra-collection-category-nav__arrow ra-collection-category-nav__arrow--prev" aria-label="Scorri categorie a sinistra">${arrowMarkup('prev')}</button>
      <div class="ra-collection-category-nav__scroll">
        <div class="ra-collection-category-nav__track">${linksMarkup}</div>
      </div>
      <button type="button" class="ra-collection-category-nav__arrow ra-collection-category-nav__arrow--next" aria-label="Scorri categorie a destra">${arrowMarkup('next')}</button>`;

    const container = section.querySelector(':scope > .container-full, :scope > .container-fluid, :scope > .container') || section;
    container.appendChild(generated);

    const track = generated.querySelector('.ra-collection-category-nav__track');
    const previous = generated.querySelector('.ra-collection-category-nav__arrow--prev');
    const next = generated.querySelector('.ra-collection-category-nav__arrow--next');

    const updateArrows = () => {
      const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
      const hasOverflow = maxScroll > 4;
      previous.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
    };

    previous.addEventListener('click', () => track.scrollBy({ left: -Math.max(track.clientWidth * .72, 160), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: Math.max(track.clientWidth * .72, 160), behavior: 'smooth' }));
    track.addEventListener('scroll', updateArrows, { passive: true });
    requestAnimationFrame(updateArrows);
    window.setTimeout(updateArrows, 250);
  };

  const initialise = (root = document) => {
    if (root.matches?.('.m-image-cards')) setupSection(root);
    root.querySelectorAll?.('.m-image-cards').forEach(setupSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }

  window.addEventListener('load', () => initialise());
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
